import { render, staticRenderFns } from "./StDataTable.vue?vue&type=template&id=6764f4b2"
import script from "./StDataTable.vue?vue&type=script&lang=js"
export * from "./StDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports